import { UserRequest } from '../user/user.request';
import { SmartSavers } from '..';

class StudentRequest {}

namespace StudentRequest {


  export class Create extends UserRequest.Signup {
    birthdate: number = undefined;
    graduationYear: number = undefined;

    accessCode: string = undefined;

    currentScoreEnglish: number = undefined;
    currentScoreMath: number = undefined;
    currentScoreReading: number = undefined;
    currentScoreScience: number = undefined;

    goalScoreEnglish: number = undefined;
    goalScoreMath: number = undefined;
    goalScoreReading: number = undefined;
    goalScoreScience: number = undefined;
  }

  export class Update extends UserRequest.Signup {
    stripeId: string = undefined;
    keapId: string = undefined;
    demographicsComplete: boolean = undefined;
    birthdate: number = undefined;
    graduationYear: number = undefined;

    oldPassword: string = undefined;

    currentScoreEnglish: number = undefined;
    currentScoreMath: number = undefined;
    currentScoreReading: number = undefined;
    currentScoreScience: number = undefined;

    goalScoreEnglish: number = undefined;
    goalScoreMath: number = undefined;
    goalScoreReading: number = undefined;
    goalScoreScience: number = undefined;
  }


  export class Answer {
    exerciseProgressId: number = undefined;
    solutionId: number = undefined;
    answer: string = undefined;
    time: number = undefined;
    persistRound: boolean = undefined;
    isLastProblem: boolean = undefined;
    reviewFlagged: boolean = undefined;

    smartSaverUsed: SmartSavers = undefined;
  }

  export class ExerciseComplete {
    exerciseProgressId: number = undefined;
  }

  export class ExerciseCompleteOpenAnswer {
    exerciseProgressId: number = undefined;
    openAnswer: string = undefined;
  }

  export class AskTutor {
    body: string = undefined;
  }
}

export { StudentRequest };


